import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiDeactivateDenestImpcMapping = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdImpcDenestMappingDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.put(serviceURL, { deactivateMrdImpcDenestMappingCommand: payload.params });
};
